/**
 * This file is part of CNT: Sindicats.
 *
 * CNT: Sindicats is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * CNT: Sindicats is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * CNT: Sindicats.  If not, see <https://www.gnu.org/licenses/>.
 */
import apiFetch from '@wordpress/api-fetch';
import { createReduxStore, register } from '@wordpress/data';

const selectors = {
	getSyndicate( state ) {
		return state.syndicate;
	},
};

const actions = {
	setSyndicate( syndicate ) {
		return {
			type: 'SET_SYNDICATE',
			syndicate,
		};
	},
	getSyndicate( path ) {
		return {
			type: 'GET_SYNDICATE',
			path,
		};
	},
};

const resolvers = {
	* getSyndicate() {
		const syndicate = yield actions.getSyndicate( '/cnt/v1/syndicate/self' );
		return actions.setSyndicate( syndicate );
	},
};

const controls = {
	GET_SYNDICATE( action ) {
		return apiFetch( { path: action.path } );
	},
};

function reducer( state = { syndicate: null }, action ) {
	switch ( action.type ) {
		case 'SET_SYNDICATE':
			return {
				...state,
				syndicate: action.syndicate,
			};
	}
	return state;
}

const store = createReduxStore( 'cnt/syndicate', {
	actions,
	controls,
	reducer,
	resolvers,
	selectors,
} );

register( store );

export default store;
